<template>
  <div>FAVORITE</div>
</template>

<script>
export default {

}
</script>

<style>

</style>